import {
  HttpRequestModelType,
  HttpRequestStatus,
  HttpPostRequestModel,
} from 'shared/domain/httpRequest/httpRequestModel';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import type { WorkflowDecisionInDto } from 'shared/domain/workflow/types';

export interface DecisionCreateRequestData {
  decisionDto: WorkflowDecisionInDto;
  projectId: string;
  issueId: string;
  uniqueId: string;
}

export type DecisionCreateRequestModel = HttpPostRequestModel<
  DecisionCreateRequestData,
  HttpRequestModelType.workflowDecision
>;

export interface CreateDecisionUseCase {
  execute(
    decisionDto: WorkflowDecisionInDto,
    projectId: string,
    issueId: string,
    uniqueId: string
  ): Promise<void>;
}

export class DecisionSaver implements CreateDecisionUseCase {
  constructor(
    private addRequest: (request: DecisionCreateRequestModel) => Promise<unknown>
  ) {}

  async execute(
    decisionDto: WorkflowDecisionInDto,
    projectId: string,
    issueId: string,
    uniqueId: string
  ): Promise<void> {
    debugLog('DecisionSaver.execute', decisionDto);
    const request: DecisionCreateRequestModel = {
      createdAt: Date.now(),
      method: 'POST',
      url: `/project/${projectId}/issue/${issueId}/workflowDecision`,
      data: {
        decisionDto,
        projectId,
        issueId,
        uniqueId,
      },
      entityType: HttpRequestModelType.workflowDecision,
      status: HttpRequestStatus.NEW,
    };

    await this.addRequest(request);
  }
}

export const decisionSaver = new DecisionSaver(addRequest);
